import { http } from '../request'
import type {
    AdminPaymentOrderListRequest,
    AdminCancelPaymentRequest,
    AdminCompleteTransactionRequest,
    AdminConfirmPaymentRequest,
    SellerConfirmReturn,
    AdminPaymentOrderListResponse,
    AdminPaymentOrderDetailResponse,
    AdminCancelPaymentResponse,
    AdminCompleteTransactionResponse,
    AdminConfirmPaymentResponse,
    AdminForceBuyerCompleteResponse,
    AdminForceSellerConfirmResponse,
    AdminRestoreOrderResponse,
    AdminOrderStatisticsResponse
} from '../types_admin/payments'
import type { AdminForceCompleteRequest } from '../types/payments'

/**
 * 管理员支付订单管理 API
 */
export const adminPaymentsApi = {
    /**
     * 获取支付订单列表
     * GET /api/admin/payments/orders/
     */
    getOrderList(params?: AdminPaymentOrderListRequest): Promise<AdminPaymentOrderListResponse> {
        return http.list('/api/admin/payments/orders/', params)
    },

    /**
     * 获取支付订单详情
     * GET /api/admin/payments/orders/{id}/
     */
    getOrderDetail(id: number): Promise<AdminPaymentOrderDetailResponse> {
        return http.get(`/api/admin/payments/orders/${id}/`)
    },

    /**
     * 获取管理员订单统计数据
     * GET /api/admin/payments/orders/statistics/
     */
    getOrderStatistics(): Promise<AdminOrderStatisticsResponse> {
        return http.get<AdminOrderStatisticsResponse>('/api/admin/payments/orders/statistics/')
    },

    /**
     * 管理员取消支付
     * POST /api/admin/payments/orders/{id}/cancel-payment/
     */
    cancelPayment(id: number, data?: AdminCancelPaymentRequest): Promise<AdminCancelPaymentResponse> {
        return http.post(`/api/admin/payments/orders/${id}/cancel-payment/`, data)
    },

    adjustPendingDeposit(id: number, data: { deposit_amount: number; reason?: string }): Promise<AdminPaymentOrderDetailResponse> {
        return http.post(`/api/admin/payments/orders/${id}/adjust-pending-deposit/`, data)
    },

    /**
     * 管理员最终确认交易完成
     * POST /api/admin/payments/orders/{id}/complete-transaction/
     */
    completeTransaction(id: number, data?: AdminCompleteTransactionRequest): Promise<AdminCompleteTransactionResponse> {
        return http.post(`/api/admin/payments/orders/${id}/complete-transaction/`, data)
    },

    /**
     * 管理员确认支付
     * POST /api/admin/payments/orders/{id}/confirm-payment/
     */
    confirmPayment(id: number, data?: AdminConfirmPaymentRequest): Promise<AdminConfirmPaymentResponse> {
        return http.post(`/api/admin/payments/orders/${id}/confirm-payment/`, data)
    },

    /**
     * 管理员强制租客确认完成
     * POST /api/admin/payments/orders/{id}/force-buyer-complete/
     */
    forceBuyerComplete(id: number): Promise<AdminForceBuyerCompleteResponse> {
        return http.post(`/api/admin/payments/orders/${id}/force-buyer-complete/`)
    },

    /**
     * 管理员强制卖家确认归还
     * POST /api/admin/payments/orders/{id}/force-seller-confirm/
     */
    forceSellerConfirm(id: number, data: SellerConfirmReturn): Promise<AdminForceSellerConfirmResponse> {
        return http.post(`/api/admin/payments/orders/${id}/force-seller-confirm/`, data)
    },

    /**
     * 恢复已删除的订单
     * POST /api/admin/payments/orders/{id}/restore/
     */
    restoreOrder(id: number): Promise<AdminRestoreOrderResponse> {
        return http.post(`/api/admin/payments/orders/${id}/restore/`)
    },

    /**
     * 管理员撤回卖家确认（回退到租客确认完成阶段并清空消耗数据）
     * POST /api/admin/payments/orders/{id}/revoke/
     */
    revokeOrder(id: number): Promise<void> {
        return http.post(`/api/admin/payments/orders/${id}/revoke/`)
    },

    /**
     * 管理员强制完成订单（一步到位完成整个交易流程）
     * POST /api/admin/payments/orders/{id}/force-complete/
     */
    forceComplete(id: number, data: AdminForceCompleteRequest): Promise<void> {
        return http.post(`/api/admin/payments/orders/${id}/force-complete/`, data)
    }
} 
